import * as yup from 'yup';

export const movimientoValidationSchema = yup.object({
  montoProveedor: yup.number('Solo se aceptan numeros').nullable(true),
  tipoMovimiento: yup.string('Solo se aceptan caracteres').oneOf(['AGREGAR', 'RETIRAR']),
  UserId: yup.string().max(4, 'Id invalida'),
  noSeComputa: yup.boolean().nullable(true),
  descripcion: yup.string().required('La descripción es requerida').trim(),
});
